/**
 * Created by Languagenut on 18/04/2019.
 */

 
import React  from 'react';
import Base from './assign_library_step.js';
import ClassesStore from '../../../store/classes-store'
import UserStore from '../../../store/user-store'
import Constants from '../../../constants.js';
import Translation from '../../../store/internationalization-store.js'
import HomeworkStore from '../../../store/homework-store'
import AssignmentsService from '../../../services/assignments-service'

class Comfirmation extends Base.component {

    constructor(props) {
        super();
    }

    componentWillMount(){

        UserStore.on(Constants.GET_MY_ASSIGNMENTS, function() {
            var homeworks = UserStore.archived;


            for(var key in homeworks) {
                if(!homeworks.hasOwnProperty(key)) continue;
                if(homeworks[key].id == this.props.information.homeworkID)
                {
                    this.props.data.homeworkID = this.props.information.homeworkID;
                    this.props.data.language = {ietf:homeworks[key].languageCode};
                    this.setState({
                        homework:homeworks[key],
                        homeworkName:homeworks[key].name,
                        loaded:true,
                        isRepeatable:homeworks[key].isRepeatable == "1",
                        tasks:homeworks[key].tasks,
                        comment:homeworks[key].homework_comment,
                    })
                    break;

                }

            }
        }.bind(this));

        UserStore.on(Constants.GET_MY_ARCHIVED_ASSIGNMENTS, function() {
            var homeworks = UserStore.assignments;


            for(var key in homeworks) {
                if(!homeworks.hasOwnProperty(key)) continue;
                if(homeworks[key].id == this.props.information.homeworkID)
                {
                    this.props.data.homeworkID = this.props.information.homeworkID;
                    this.props.data.language = {ietf:homeworks[key].languageCode};
                    this.setState({
                        homework:homeworks[key],
                        loaded:true,
                        homeworkName:homeworks[key].name,
                        isRepeatable:homeworks[key].isRepeatable == "1",
                        tasks:homeworks[key].tasks,
                        comment:homeworks[key].homework_comment,
                    })
                    break;

                }

            }
        }.bind(this));



        ClassesStore.on(Constants.GET_CLASSES_LIST,  ()=>{
            var classes = ClassesStore.list;

            AssignmentsService.getUsersCompleted(this.props.information.homeworkID).then(function(students){

                var classStates = {};
                var classMine = []
                for(var idx = 0 ; idx < classes.length; idx++)
                {
                    var selected = false;
                    var students = [];
                    classStates[classes[idx].uid] = {allStudents:true , selected:selected ? true : students.length > 0 ? true : false , students:students};
                    if (classes[idx].isMine) {
                        classMine.push(classes[idx]);
                    }
                }

                this.setState({
                    classes:classes,
                    classStates:classStates,
                    classMine:classMine
                });

            }.bind(this));

        })

    }



    handleHomeworkSubmission(){
        this.convert();

        var $homeworkName = this.state.homeworkName;
        var $comment = this.state.comment;
        var $toDate = this.state.endDate;
        var $fromDate = this.state.startDate;
        var $isRepeatable = this.state.isRepeatable;
        var $overallData = HomeworkStore.getCurrentHomeworks();
        for (var i = 0; i < $overallData.length; i++) {
            $overallData[i]['data'] = undefined;
        }
        var $totalClass = [];
        var $studentsOnly = [];

        for (var classUid in this.state.classStates){
            if (this.state.classStates.hasOwnProperty(classUid)) {
                if (this.state.classStates[classUid].selected == true &&
                    this.state.classStates[classUid].students.length == 0) {
                    $totalClass.push(classUid);
                } else if (this.state.classStates[classUid].students != undefined &&
                    this.state.classStates[classUid].students != null &&
                    this.state.classStates[classUid].students.length > 0){
                    $studentsOnly = $studentsOnly.concat(this.state.classStates[classUid].students);
                }
            }
        }

        return AssignmentsService.duplicateAssignment(
                this.props.information.homeworkID , $homeworkName, $toDate, $fromDate, $isRepeatable, 
                $totalClass, $studentsOnly, $comment).then(function(response) {
                var homeWorkUid = response.homework;
                return homeWorkUid;
            });
    }

}


export default {
    name: function() {return Translation.get(2439 ,'Assign Library Assignment')},
    icon:<i class="fa-2x fas fa-file-alt"></i>,
    title:null,
    disableButtons:true,
    onSubmit: function (done){
        done();
    },
    component: Comfirmation
}